module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "sdd",
    staticClass: "site-detail"
  }, [_c('div', {
    staticClass: "padded",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('el-row', {
    attrs: {
      "align": "bottom"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 21
    }
  }, [_c('h1', {
    class: _vm.titleClass(_vm.siteData.status)
  }, [_vm._v(_vm._s(_vm.siteData.siteName)), (_vm.siteData.telcoSiteId) ? _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" | " + _vm._s(_vm.siteData.telcoSiteId))]) : _vm._e()]), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.siteStatus(_vm.siteData.status))
    }
  }), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.isCandidate(_vm.siteData.status) && _vm.siteData.candidate && _vm.siteData.candidate.name ? ' for ' + _vm.siteData.candidate.name : ''))]), _vm._v(" "), _c('span', [(_vm.siteData.structure.name) ? _c('span', [_c('b', [_vm._v(_vm._s(_vm.siteData.structure.name))])]) : _vm._e(), _vm._v(" "), (_vm.siteData.structure.height) ? _c('span', [_vm._v(" | "), _c('b', [_vm._v(_vm._s(_vm.siteData.structure.height))]), _vm._v("m.")]) : _vm._e(), _vm._v("\n          | " + _vm._s(_vm.siteData.siteId) + "\n        ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "align": "right",
      "span": 3
    }
  }, [(_vm.isTowerCo() && !_vm.isSold(_vm.rowData.status)) ? _c('site-action', {
    attrs: {
      "site-data": _vm.siteData
    },
    on: {
      "change": _vm.siteChanged
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.isTowerCo()) ? _c('el-row', {
    staticClass: "text-muted"
  }, [(_vm.siteData.active || _vm.siteData.dismantled) ? _c('el-col', {
    class: !_vm.siteData.dismantled ? 'text-success' : 'text-danger',
    attrs: {
      "span": 8
    }
  }, [_c('small', [_vm._v(_vm._s(!_vm.siteData.dismantled ? 'Active' : 'Dismantled') + " ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.formatDate(!_vm.siteData.dismantled ? _vm.siteData.active : _vm.siteData.dismantled)))]), _vm._v(" "), _c('span', [_vm._v("\n            ("), _c('i', [_vm._v(_vm._s(_vm.formatFriendlyDate(!_vm.siteData.dismantled ? _vm.siteData.active : _vm.siteData.dismantled)))]), _vm._v(")\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.siteData.handover) ? _c('el-col', {
    attrs: {
      "span": (_vm.siteData.active || _vm.siteData.dismantled) ? 8 : 16,
      "align": (_vm.siteData.active || _vm.siteData.dismantled) ? 'center' : 'left'
    }
  }, [_c('small', [_vm._v("Handover ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.formatDate(_vm.siteData.handover)))]), _vm._v("\n        ("), _c('i', [_vm._v(_vm._s(_vm.formatFriendlyDate(_vm.siteData.handover)))]), _vm._v(")\n      ")]) : _vm._e(), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "font-size": "8pt"
    },
    attrs: {
      "align": "right",
      "span": !_vm.siteData.handover && (_vm.siteData.active || _vm.siteData.dismantled) ? 16 : (_vm.siteData.handover ? 8 : 24)
    }
  }, [_c('small', [_vm._v("Last Update ")]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": _vm.formatDateTime(_vm.siteData.updated_at) + (_vm.siteData.updated_by ? ' by ' + _vm.siteData.updated_by : '')
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.formatFriendlyDate(_vm.siteData.updated_at)))])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sites-view"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "xs": 3,
      "sm": 3,
      "md": 24,
      "lg": 24
    }
  }, [_c('el-menu', {
    attrs: {
      "default-active": _vm.menu,
      "mode": _vm.isDesktop ? 'horizontal' : 'vertical',
      "background-color": "#F0F8FF",
      "active-text-color": "#409EFF"
    },
    on: {
      "select": _vm.selectView
    }
  }, [(!_vm.isCandidate(_vm.rowData.status)) ? _c('el-menu-item', {
    attrs: {
      "index": "info"
    }
  }, [_c('sites-menu-badge', {
    attrs: {
      "title": "Info",
      "prop": "info",
      "data": _vm.stats,
      "icon": "info"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isTowerCo() && _vm.canAccess('project|maintenance|finance|admin')) ? _c('el-menu-item', {
    attrs: {
      "index": "calendar"
    }
  }, [_c('sites-menu-badge', {
    attrs: {
      "title": "Calendar",
      "prop": "calendar",
      "data": _vm.stats,
      "icon": "calendar-days"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isTowerCo() && _vm.canAccess('project|maintenance|finance|admin')) ? _c('el-menu-item', {
    attrs: {
      "index": "actions"
    }
  }, [_c('sites-menu-badge', {
    attrs: {
      "title": "Actions",
      "prop": "actions",
      "data": _vm.stats,
      "icon": "asterisk"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isTowerCo() && _vm.canAccess('project|maintenance|finance|admin')) ? _c('el-menu-item', {
    attrs: {
      "index": "requests"
    }
  }, [_c('sites-menu-badge', {
    attrs: {
      "title": "Requests",
      "prop": "requests",
      "data": _vm.stats,
      "icon": "share-alt"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.isTelco() || _vm.isTowerCo()) && !_vm.isLandOnly(_vm.siteData.status) && !_vm.isSold(_vm.siteData.status) && _vm.canAccess('project|management|property|maintenace|finance|admin')) ? _c('el-menu-item', {
    attrs: {
      "index": "candidate"
    }
  }, [_c('sites-menu-badge', {
    attrs: {
      "title": "Candidate",
      "prop": "candidates",
      "data": _vm.stats,
      "icon": "street-view"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "equip"
    }
  }, [_c('sites-menu-badge', {
    attrs: {
      "title": "Equipment",
      "prop": "assets",
      "data": _vm.stats,
      "icon": "cogs"
    }
  })], 1), _vm._v(" "), (!_vm.isSold(_vm.siteData.status) && _vm.canAccess('project|maintenance|management')) ? _c('el-menu-item', {
    attrs: {
      "index": "maint"
    }
  }, [_c('sites-menu-badge', {
    attrs: {
      "title": "Maintenance",
      "prop": "tickets",
      "data": _vm.stats,
      "icon": "headset"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.isTowerCo() || _vm.isContractorCo()) && !_vm.isSold(_vm.siteData.status) && _vm.canAccess('project|maintenance|management')) ? _c('el-menu-item', {
    attrs: {
      "index": "workflow"
    }
  }, [_c('sites-menu-badge', {
    attrs: {
      "title": "Workflows",
      "prop": "workflow",
      "data": _vm.stats,
      "icon": "tasks"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.isTowerCo() || _vm.isTowerSupplierCo()) || _vm.canAccess('project|maintenance|management') && !_vm.isLandOnly(_vm.siteData.status)) ? _c('el-menu-item', {
    attrs: {
      "index": "struct"
    }
  }, [_c('sites-menu-badge', {
    attrs: {
      "title": "Structure",
      "data": _vm.stats,
      "icon": "broadcast-tower"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isTowerCo() && !_vm.isLandOnly(_vm.siteData.status)) ? _c('el-menu-item', {
    attrs: {
      "index": "attach"
    }
  }, [_c('sites-menu-badge', {
    attrs: {
      "title": "Attachments",
      "prop": "files",
      "data": _vm.stats,
      "icon": "paperclip"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isTowerCo() && _vm.canAccess('project|maintenance|finance|management') && !_vm.isLandOnly(_vm.siteData.status)) ? _c('el-menu-item', {
    attrs: {
      "index": "sharers"
    }
  }, [_c('sites-menu-badge', {
    attrs: {
      "title": "Sharers",
      "prop": "sharers",
      "data": _vm.stats,
      "icon": "users"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.isTowerCo() || _vm.isLandlordCo()) || _vm.canAccess('property|finance|management')) ? _c('el-menu-item', {
    attrs: {
      "index": "tenancy"
    }
  }, [_c('sites-menu-badge', {
    attrs: {
      "title": "Tenancy",
      "data": _vm.stats,
      "icon": "store-alt"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.isTowerCo() || _vm.isAuthority()) || _vm.canAccess('project|property|finance|admin|management')) ? _c('el-menu-item', {
    attrs: {
      "index": "permits"
    }
  }, [_c('sites-menu-badge', {
    attrs: {
      "title": "Permits",
      "prop": "permits",
      "data": _vm.stats,
      "icon": "clipboard"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.isTowerCo() || _vm.isInsuranceCo()) || _vm.canAccess('property|finance|admin|management')) ? _c('el-menu-item', {
    attrs: {
      "index": "ins"
    }
  }, [_c('sites-menu-badge', {
    attrs: {
      "title": "Insurance",
      "prop": "insurance",
      "data": _vm.stats,
      "icon": "shield-alt"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.isTowerCo() || _vm.isUtility()) || _vm.canAccess('admin|management')) ? _c('el-menu-item', {
    attrs: {
      "index": "power"
    }
  }, [_c('sites-menu-badge', {
    attrs: {
      "title": "Power",
      "prop": "power",
      "data": _vm.stats,
      "icon": "plug"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isTowerCo() && !_vm.isSold(_vm.siteData.status) || _vm.canAccess('finance|management') && !_vm.isLandOnly(_vm.siteData.status)) ? _c('el-menu-item', {
    attrs: {
      "index": "finance"
    }
  }, [_c('sites-menu-badge', {
    attrs: {
      "title": "Finance",
      "prop": "finance",
      "data": _vm.stats,
      "icon": "money-bill-alt"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.isTowerCo() || _vm.isTelco() || _vm.isBackhaulCo()) || _vm.canAccess('finance|management|maintenance|project')) ? _c('el-menu-item', {
    attrs: {
      "index": "backhaul"
    }
  }, [_c('sites-menu-badge', {
    attrs: {
      "title": "Backhaul",
      "prop": "backhaul",
      "data": _vm.stats,
      "icon": "wifi"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.comp) ? _c('el-col', {
    attrs: {
      "xs": 21,
      "sm": 21,
      "md": 24,
      "lg": 24
    }
  }, [_c(_vm.comp, _vm._b({
    tag: "component",
    on: {
      "view": _vm.selectView
    }
  }, 'component', _vm.defaultProps, false))], 1) : _vm._e()], 1), _vm._v(" "), (!_vm.isCandidate(_vm.rowData.status)) ? _c('google-map', {
    attrs: {
      "lat": _vm.rowData.latitude,
      "lng": _vm.rowData.longitude,
      "zoom": 18
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isCandidate(_vm.rowData.status)) ? _c('section', [_c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('site-card', {
    attrs: {
      "site-data": _vm.rowData,
      "markers": _vm.markers,
      "map-type": "terrain",
      "map-style": _vm.mapStyle,
      "zoom": 16,
      "hide-site": "",
      "no-structure": ""
    }
  })], 1)], 1)], 1) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e18934d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tables/details/SiteDetails.vue
// module id = 1419
// module chunks = 0